export default {
  common: {
    cancel: "Annulla",
    add: "Aggiungi",
    back: "Indietro", 
    next: "Avanti", 
    submit: "Invia",
    saving: "Salvataggio…",
    saved: "Salvato ✓",
  },
  menu: {
    backToDashboard: "Torna alla dashboard",
    myObjects: "Le mie strutture",
    settings: "Impostazioni",
    help: "Aiuto / Contatto",
    logout: "Disconnetti",
    language: "Italiano",
  },

  contact: {
    title: "Contatto",
    subtitle: "Come possiamo aiutarti?",
    messageLabel: "Il tuo messaggio",
    send: "Invia messaggio",
    success: "Messaggio inviato con successo!",
    close: "Chiudi",
  },

  dashboard: {
    welcome: "Bentornato, ",
    overview: "La mia panoramica",
    summaryText: "Qui trovi una rapida panoramica sullo stato delle tue strutture.",
    activeObjects: "Struttura/e online",
    inReviewObjects: "Struttura/e in revisione",

    contact: "I miei dati di contatto",
    editContact: "Modifica",

    settings: "Le mie impostazioni",
    subscription: "Abbonamento",
    subscriptionActive: "Attivo",
    password: "Password",
    changePassword: "Cambia password",

    objects: "Le mie strutture",
    objectboxText: "Inserisci disponibilità e prezzi",
    objectboxText2: "Modifica i dati della struttura",
    objectbuttonText: "Gestisci strutture",

    newObjectContainer: "Crea una nuova struttura",
    newObjectDescription: "Crea una nuova struttura o continua una bozza esistente.",
    continueDraft: "➜ Continua la compilazione",
    newObject: "+ Crea nuova struttura",

    documents: "Documenti",
    lastInvoice: "Ultima fattura",
    openArchive: "Apri archivio",
  },

  contactEdit: {
    title: "Modifica dati di contatto",
    errorLoading: "Errore durante il caricamento dei dati.",
    errorSaving: "Errore durante il salvataggio dei dati.",
    confirmLeave: "Vuoi salvare le modifiche?",
    salutation: "Titolo",
    selectSalutation: "Seleziona un titolo",
    company: "Azienda",
    firstName: "Nome",
    lastName: "Cognome",
    street: "Via",
    houseNumber: "Numero civico",
    postalCode: "CAP",
    town: "Città / Località",
    country: "Paese",
    selectCountry: "Seleziona un paese",
    phone: "Numero di telefono",
    cancel: "Annulla",
    save: "Salva",
    requiredFields: "Compila tutti i campi obbligatori.",
  },

  registerUser: {
    title: "Dati di contatto",
    verifiedMessage: "La tua email è stata verificata con successo. Ora inserisci i tuoi dati di contatto.",

    salutation: "Titolo",
    selectSalutation: "Seleziona un titolo",
    company: "Azienda (opzionale)",
    firstName: "Nome",
    lastName: "Cognome",
    street: "Via",
    houseNumber: "Numero civico",
    postalCode: "CAP",
    town: "Città / Località",
    country: "Paese",
    selectCountry: "Seleziona un paese",

    phone: "Numero di telefono",
    phonePlaceholder: "Numero di telefono",
    phoneCodePlaceholder: "Prefisso",
    search: "Cerca...",
    noResults: "Nessun risultato",

    terms: "Accetto i",
    termsLink: "Termini e condizioni",
    privacy: "Accetto l'",
    privacyLink: "Informativa sulla privacy",

    save: "Salva dati",

    requiredFields: "Compila tutti i campi obbligatori.",
    acceptTerms: "Accetta i termini e l'informativa sulla privacy.",
    loginFirst: "Effettua prima l'accesso.",
    errorSaving: "Errore durante il salvataggio dei dati!",
    errorLoading: "Errore durante il caricamento dei dati.",
  },

  password: {
    title: "Cambia password",
    oldPassword: "Password attuale",
    newPassword: "Nuova password",
    confirmPassword: "Conferma nuova password",

    cancel: "Annulla",
    save: "Salva",

    errorInvalid: "Compila correttamente tutti i campi.",
    errorGeneral: "Errore durante il cambio della password.",
    success: "Password cambiata con successo.",
    confirmLeave: "Vuoi salvare le modifiche?",
  },

  impressum: {
    title: "Note legali",
    company: "glampingoase GmbH",
    addressLine1: "Breechliweg 3",
    addressLine2: "5102 Rupperswil",
    country: "Svizzera",

    registryNumber: "Numero di registro: CHE-432.303.436",
    registryCourt: "Registro: Ufficio del registro di commercio del Canton Argovia",

    emailLabel: "E-mail",
  },

  footer: {
    impressum: "Note legali",
  },

  objectList: {
    title: "Gestisci disponibilità e prezzi",
    loading: "Caricamento...",
    notConfirmed: "non ancora confermato",
    editPrices: "Modifica prezzi",
    editAvailability: "Modifica disponibilità",
    noObjectsLine1: "Nessuna struttura ancora creata.",
    noObjectsLine2: "Vuoi crearne una ora?",
    createObject: "Crea nuova struttura",
    imageAlt: "Immagine struttura",
  },

  prices: {
    openCalendar: "Apri calendario",
    datePlaceholder: "gg.mm.aaaa",
    object: "Struttura",

    errorFetchCurrency: "Errore durante il caricamento della valuta",
    errorFetchObjects: "Errore durante il caricamento delle strutture",
    errorFetchObjectName: "Errore durante il caricamento del nome della struttura",
    errorFetchSeasons: "Errore durante il caricamento delle stagioni",
    errorFetchSeasonsAlert: "Si è verificato un problema durante il caricamento delle stagioni.",
    errorNotLoggedIn: "Non hai effettuato l'accesso.",
    errorMissingFields: "Compila tutti i campi.",
    errorEndBeforeStart: "La data di fine non può essere precedente alla data di inizio.",
    errorOverlap: "Questa stagione si sovrappone a una stagione esistente.",

    errorSaveSeason: "Errore durante il salvataggio della stagione",
    errorApiRequest: "Errore nella richiesta API",
    errorSaveSeasonAlert: "Si è verificato un problema durante il salvataggio della stagione.",

    confirmDeleteSeason: "Vuoi eliminare la stagione",
    errorDeleteSeason: "Errore durante l'eliminazione della stagione",
    errorDeleteSeasonAlert: "La stagione non può essere eliminata.",

    errorFinishEditingFirst: "Completa prima la modifica corrente.",

    tabPrices: "Prezzi",
    tabAdditionalCosts: "Costi aggiuntivi",
    tabCurrency: "Valuta",
    tabAvailability: "Disponibilità",
    tabObjectList: "Panoramica strutture",

    pricesFor: "Prezzi per",

    hidePastSeasons: "Nascondi stagioni passate",
    showPastSeasons: "Mostra stagioni passate",

    seasonName: "Nome stagione",
    pricePerNight: "Prezzo per notte in",

    saving: "Salvataggio...",
    cancel: "Annulla",
    addSeason: "+ Aggiungi stagione",

    infoTitle: "Come inserire i prezzi?",
    infoText:
      "Per ogni stagione definisci un periodo con data di inizio e fine.\n\n" +
      "Puoi assegnare un nome qualsiasi alla stagione. Serve solo per la tua organizzazione interna e non viene mostrato ai clienti.\n\n" +
      "Il prezzo si riferisce al costo per notte. Assicurati che i periodi delle stagioni non si sovrappongano. In caso contrario, apparirà un messaggio di errore.\n\n" +
      "Quando tutti i dati sono corretti, conferma tramite la spunta verde. La stagione verrà salvata e potrai aggiungerne un'altra.\n\n" +
      "È possibile modificare solo una stagione alla volta, poiché ogni modifica attiva un controllo automatico delle sovrapposizioni.\n\n" +
      "Le stagioni già salvate possono essere modificate tramite l'icona della matita o eliminate tramite il cestino. Queste azioni sono disponibili solo quando non stai modificando un'altra stagione.\n\n" +
      "Puoi visualizzare le stagioni passate tramite il pulsante 'Mostra stagioni passate'. Queste sono solo a scopo informativo e non possono essere modificate.",

    close: "Chiudi",

    selectCurrencyTitle: "Seleziona la valuta",
    selectCurrencyText: "Scegli una valuta prima di aggiungere i prezzi.",
    currencyRequired: "Seleziona prima una valuta.",

  },

  additionalCosts: {
    title: "Costi aggiuntivi per",
    object: "Struttura",

    add: "Aggiungi costo aggiuntivo",

    selectType: "Seleziona tipo di costo",
    selectUnit: "Seleziona unità",
    pricePlaceholder: "Prezzo in",

    saving: "Salvataggio...",
    cancel: "Annulla",

    finishEditingFirst: "Completa prima la modifica corrente.",
    fillAllFields: "Compila tutti i campi.",
    confirmDelete: "Vuoi davvero eliminare questo costo?",

    errorLoadingTypes: "Errore durante il caricamento dei tipi di costo",
    errorLoadingUnits: "Errore durante il caricamento delle unità",
    errorLoadingCosts: "Errore durante il caricamento dei costi",
    errorSaving: "Errore durante il salvataggio",
    errorDeleting: "Errore durante l'eliminazione",
  },

  currency: {
    title: "Valuta per",
    select: "Seleziona valuta",
    saving: "Salvataggio...",
    save: "Salva valuta",
    saved: "Valuta salvata con successo",
    errorLoadingCurrencies: "Errore durante il caricamento delle valute disponibili",
    errorLoadingObjectCurrency: "Errore durante il caricamento della valuta della struttura",
    errorLoadingObjectName: "Errore durante il caricamento del nome della struttura",
    errorSaving: "Errore durante il salvataggio della valuta",
    object: "Struttura",
  },

availability: {
  settingsTitle: "Impostazioni",
  modeTitle: "Modalità disponibilità",
  modeIcal: "Sincronizzazione iCal",
  modeManual: "Disponibilità manuali",

  warningSwitch: "Cambiare modalità eliminerà le disponibilità esistenti. Continuare?",
  saved: "Impostazioni salvate.",

  modalTitle: "Come desideri gestire le tue disponibilità?",
  modalText: "Scegli una delle due opzioni. Puoi modificarla in qualsiasi momento.",
  chooseIcal: "Sincronizzazione iCal",
  chooseManual: "Inserimento manuale",

  errorLoading: "Errore durante il caricamento delle disponibilità.",
  tabsAriaLabel: "Schede disponibilità",

  tabSettings: "Impostazioni",
  tabIcal: "Gestisci iCal",
  tabManual: "Inserisci disponibilità",
  tabPrices: "Prezzi",
  tabObjectList: "Elenco oggetti"
},

availabilityManual: {
  editAvailability: "Modifica disponibilità",
  loadingObject: "Caricamento informazioni dell’oggetto…",

  legendAvailable: "Disponibile",
  legendDelete: "Elimina",

  savedSuccess: "Disponibilità salvate con successo!",
  savedPartialError: "Alcune disponibilità non sono state salvate o eliminate.",
  errorSaving: "Errore durante il salvataggio.",
  errorNoObjectId: "Errore: nessun ID oggetto trovato."
},

availabilityIcal: {
  title: "Importazione iCal",
  loading: "Caricamento…",

  placeholderUrl: "https://esempio.com/calendario.ics",
  testPreview: "Test anteprima",
  testing: "Test…",
  showSynced: "Mostra dati sincronizzati",

  save: "Salva",
  saving: "Salvataggio...",
  remove: "Rimuovi",

  lastSync: "Ultima sincronizzazione",
  previewFailed: "Anteprima non riuscita",
  previewCalendar: "Anteprima (calendario)",

  prev: "Indietro",
  next: "Avanti",

  errorLoading: "Errore nel caricamento dei dati iCal.",
  errorNoUrl: "Nessun link iCal fornito.",
  errorPreview: "Errore durante il recupero del link.",
  errorInvalidUrl: "URL non valido.",
  errorSaving: "Errore durante il salvataggio.",
  errorRemove: "Errore durante la rimozione",
  removed: "Link iCal rimosso",
  saved: "Link iCal salvato. Sincronizzazione avviata.",
  errorLoadSynced: "Errore nel caricamento dei dati sincronizzati.",
  errorNoObjectId: "Nessun ID oggetto trovato."
},

  newObjectModal: {
    title: "Struttura incompleta trovata",
    description:
      "Hai già iniziato a creare una struttura. Vuoi continuare o ricominciare da capo sovrascrivendo i dati esistenti?",
    continue: "Continua compilazione",
    startNew: "Inizia da capo",
  },

  object: {
    tabs: [
      "Dati principali",
      "Stanze",
      "Dotazioni / Ambiente",
      "Occupazione",
      "Descrizione",
      "Immagini",
      "Invio"
    ],

    step1: {
      title: "Passo 1: Informazioni generali",

      fields: {
        name: "Nome struttura",
        street: "Via",
        house_number: "Numero civico",
        postal_code: "CAP",
        city: "Città",
        object_type: "Tipo di struttura",
        country: "Paese",
        region: "Regione",
        licence_number: "Numero di licenza",
      },

      select: {
        choose: "Seleziona",
      },

      map: {
        info: "Il marker viene posizionato automaticamente in base all'indirizzo inserito. Se non è preciso, puoi spostarlo manualmente.",
        reset: "Reimposta marker sull'indirizzo inserito",
        load_error: "Impossibile caricare la mappa.",
        loading: "Caricamento mappa...",
      },

      geocode: {
        failed: "Geocodifica non riuscita.",
        missing_fields:
          "Compila tutti i campi dell'indirizzo e verifica che l'API di Google Maps sia caricata.",
      },
    },
      step2: {
        title: "Passo 2: Stanze e servizi",
        addRoom: "Aggiungi stanza",
        roomCountTitle: "Quante stanze ha la tua struttura?",
        roomCountDescription: "Inserisci il numero per ogni tipo di stanza. Poi potrai modificarle singolarmente.",
        roomCountSharedHint: "Anche le stanze condivise come bagno e cucina contano.",
        addAllRooms: "Aggiungi tutte le stanze",
        roomType: "Tipo di stanza",
        amount: "Quantità",
        select: "Seleziona",
        usage: "Utilizzo",
        private: "Uso privato",
        shared: "Uso condiviso",
        onlyOneAllowed: "solo 1 consentito",

        // Beds
        beds: "Letti",
        addBed: "Aggiungi letto",
        bedType: "Tipo di letto",
        size: "Dimensione",
        sizeWidth: "Larghezza (cm)",
        sizeLength: "Lunghezza (cm)",
        sizeOptional: "Opzionale",
      },

      step3: {
        title: "Passo 3: Dotazioni e dintorni",
        general: "Dotazioni generali",
        outdoor: "Dotazioni esterne",
        environmentAmenities: "Dotazioni dell’ambiente",
        environmentCards: "Dintorni",
        errorLoading: "Errore durante il caricamento delle dotazioni."
      },
      step4: {
        title: "Passo 4: Occupazione e opzioni di contatto",

        maxOccupancy: "Occupazione massima",
        maxPets: "Numero massimo di animali",
        minNights: "Soggiorno minimo",

        selectPlaceholder: "Seleziona",

        arrivalDays: "Giorni di arrivo",

        earliestCheckin: "Check-in più presto",
        latestCheckout: "Check-out più tardi",

        rules: "Regole",
        partyAllowed: "Feste permesse",
        smokingAllowed: "Fumo permesso",
        yes: "Sì",
        no: "No",

        contactOptions: "Opzioni di contatto",
        contactHow: "Come dovrebbero contattarti gli ospiti?",
        contactBoth: "Entrambi",
        contactWebsite: "Sito web",
        contactWebsitePlaceholder: "https://example.com",
        contactEmail: "Email per modulo di contatto",

        invalidEmail: "Inserisci un indirizzo email valido.",
        errorLoadingArrivalDays: "Errore durante il caricamento dei giorni di arrivo."
      },
      step5: {
        title: "Passo 5: Descrizione dell’alloggio",
        activitiesTitle: "Attività nelle vicinanze",
        activitiesPlaceholder: "Descrivi cosa si trova vicino alla tua struttura.",
        descriptionTitle: "Descrizione dell’alloggio",
        descriptionPlaceholder: "Inserisci un testo significativo che descriva bene la struttura."
      },
      step6: {
        title: "Passo 6: Carica immagini",

        titleImage: "Immagine principale",
        additionalImages: "Immagini aggiuntive (max. 20)",

        selectOrDragTitle: "Seleziona o trascina qui l’immagine principale",
        dragTitleHere: "Trascina qui l’immagine principale",

        selectOrDragAdditional: "Seleziona file o trascinali qui",
        dragAdditionalHere: "Trascina qui altre immagini",

        uploaded: "Immagine caricata",
        uploadedCount: "{n} immagine/i caricata/e",

        errorMinSize: "L’immagine deve essere almeno {w}x{h} pixel.",
        errorInvalidFormat: "Formato immagine non valido."
      },
      step7: {
        title: "Passo 7: Conclusione e scelta dell’abbonamento",
        intro: "Ci sei quasi! Scegli il tuo piano e verifica che tutti i passaggi siano completi.",

        subscriptionTitle: "Scegli il piano",

        freeTitle: "Free",
        freePrice: "Gratuito",
        freeDescription: "Testo segnaposto. Qui va la descrizione.",

        monthlyTitle: "Mensile",
        monthlyPrice: "2 CHF / mese",
        monthlyDescription: "Testo segnaposto. Qui va la descrizione.",

        yearlyTitle: "Annuale",
        yearlyPrice: "20 CHF / anno",
        yearlyDescription: "Testo segnaposto. Qui va la descrizione.",

        overviewTitle: "Riepilogo delle tue informazioni",
        fix: "Completa",

        overviewItems: [
          { step: 1, title: "Dati principali" },
          { step: 2, title: "Stanze" },
          { step: 3, title: "Dotazioni / Ambiente" },
          { step: 4, title: "Occupazione" },
          { step: 5, title: "Descrizione" },
          { step: 6, title: "Immagini" }
        ],

        errorUnknown: "Errore sconosciuto.",
        errorGeneral: "Si è verificato un errore."
      }


  },
};
